/* eslint-disable lodash/prefer-constant */
import React from 'react';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';

export function TestRouterProvider({ children, router = {} }) {
  const {
    route = '',
    pathname = '',
    query = {},
    asPath = '',
    push = async () => true,
    replace = async () => true,
    reload = () => null,
    back = () => null,
    prefetch = async () => undefined,
    beforePopState = () => null,
    isFallback = false,
    isReady = true,
    events = {
      on: () => null,
      off: () => null,
      emit: () => null,
    },
  } = router;

  return (
    <RouterContext.Provider
      value={{
        route,
        pathname,
        query,
        asPath,
        push,
        replace,
        reload,
        back,
        prefetch,
        beforePopState,
        isFallback,
        isReady,
        events,
      }}
    >
      {children}
    </RouterContext.Provider>
  );
}
